import { Icon as Iconify, IconProps } from '@iconify/react';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const Icon: React.FC<IconProps> = (props) => {
  const { icon, ...rest } = props;

  // =============== VIEWS
  return <Iconify icon={icon} fontSize="1.5rem" {...rest} />;
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Icon;
